import React,{useRef} from 'react';
import { Component } from 'react';
import ReactDOM from 'react-dom';

import Header from "../components/header";
import Info from "../components/random/info";

export default class Random extends Component {
    constructor(props){
        super(props)

        this.state = {
            name: '',
            film: [],
            error: null,
        }

        this.seeing = this.seeing.bind(this)
        this.see = this.see.bind(this)
        this.pending = this.pending.bind(this)
    }

    seeing(id){
        try{
            fetch(https+'api/seeing_random/'+id)
                .then(response => response.json())
                .then(data =>{
                    this.setState({
                        film:data,
                    })
                })
        }catch (error) {
            this.setState({
                error
            })
        }
    }
    
    see(id){
        try{
            fetch(https+'api/see_random/'+id)
                .then(response => response.json())
                .then(data =>{
                    this.setState({
                        film:data,
                    })
                })
        }catch (error) {
            this.setState({
                error
            })
        }
    }
    
    pending(id){
        try{
            fetch(https+'api/pending_random/'+id)
                .then(response => response.json())
                .then(data =>{
                    this.setState({
                        film:data,
                    })
                })
        }catch (error) {
            this.setState({
                error
            })
        }
    }

    async componentDidMount(){
        //banner
        try{
            let res = await fetch(https+'api/filmRandom')
            let data = await res.json()
            this.setState({
                film:data
            })
        }catch (error) {
            this.setState({
                error
            })
        }

    }
    
    render() {
        return (
            <div>
                <Header
                />
                <Info
                    film={this.state.film}
                    seeing={this.seeing}
                    see={this.see}
                    pending={this.pending}
                />
            </div>
        );
    }

}

if (document.getElementById('content_random')) {
    ReactDOM.render(<Random />, document.getElementById('content_random'))
}
